import React from 'react'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { useHistory, useLocation, useParams } from 'react-router'
import { ProvisionImpairmentDetailContent } from './ProvisionImpairmentDetailContent'

export const ProvisionImpairmentDetail = (props: any) => {
  const history = useHistory()
  const { mode } = props
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location = useLocation()
  const editData = location?.state as any

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return 'Draft'
      case 'SUBMIT':
        return 'Submitted'
      case 'COMPLETED':
        return 'Approved'
      case 'REJECTED':
        return 'Rejected'
      default:
        return 'Detail'
    }
  }

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment`
          )
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Provision for Impairment', current: true },
        ]}
        rightRouteSegments={[
          {
            name: getStatusLabel(editData?.ApprovalStatus),
            current: true,
          },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="xsTitle flex-space">
            <span style={{ fontWeight: 'bold' }}>{editData?.Asset?.name}</span>
          </span>
        }
        rightText={<span className="xsTitle">{editData?.DocNo}</span>}
        infoLine={
          <>
            <div className="desc flex-space">
              {formatDate(editData?.change_date)}
            </div>
          </>
        }
        rightInfoLine={
          <span className="desc">
            {`${amtStr(editData?.old_accumulated_impairment)}`}
            <span> → </span>
            <span style={{ color: 'orange' }}>
              {amtStr(editData?.new_accumulated_impairment)}
            </span>
          </span>
        }
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <ProvisionImpairmentDetailContent
            listEl={editData}
            listStatus={editData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
